module.exports = __webpack_public_path__ + "static/sync-api-463553f4696c3d83951c9e58fe6a60a8.png";